import PropTypes from "prop-types";
import { useMemo } from "react";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { fetchMerchandisings } from "app/pages/Merchandising/merchandisingActionCreators";
import { getCategorizedVisibleMerchandisings } from "app/pages/Merchandising/merchandisingSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import DynamicBlocksRenderer from "./DynamicBlocksRenderer";
import { paymentTypeShape } from "app/utils/propTypes";
import {
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
	shouldShowReasonToBook,
} from "app/reducers/partnerSelector";
import { fetchProducts } from "app/pages/Listing/productActionCreators";
import { getOngoingProducts } from "app/pages/Listing/productsSelector";

const DynamicBlocksRendererContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <DynamicBlocksRenderer {...props} {...stateProps} {...dispatchProps} />;
};

DynamicBlocksRendererContainer.propTypes = {
	blocks: PropTypes.array,
	dividerComponent: PropTypes.node,
	fetchMerchandisings: PropTypes.func,
	fetchProducts: PropTypes.func,
	products: PropTypes.array,
	merchandisings: PropTypes.array,
	userIsConnected: PropTypes.bool,
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	shouldShowReasonToBook: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		userIsConnected: isAuthenticated(state),
		products: getOngoingProducts(state),
		merchandisings: getCategorizedVisibleMerchandisings(state),
		availablePaymentTerms: getAvailablePaymentTerms(state),
		shouldShowReasonToBook: shouldShowReasonToBook(state),
		onlinePercentage: getPartnerDepositPercentage(state),
		destinations: state.smartDP?.destinations,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ fetchMerchandisings, fetchProducts }, dispatch);
};

export default DynamicBlocksRendererContainer;
